export class LoaFiltreCriteria {
  serviceAbrv: string;

  constructor(loaFiltreCriteria) {
    this.serviceAbrv = loaFiltreCriteria.serviceAbrv;
  }
}
